import React, { type ReactNode } from 'react';

interface GetStartedCardProps {
  icon?: ReactNode;
  number?: string;
  title: string;
  description: string;
}

export default function GetStartedCard({ icon, number, title, description }: GetStartedCardProps) {
  return (
    <div className={`space-y-3 rounded-lg p-5 ${icon ? 'box-shadow-sm bg-white' : ''}`}>
      {icon && <div className="mb-6 text-blue-400">{icon}</div>}
      {number && <h1 className="text-4xl font-light text-blue-400 opacity-50">{number}</h1>}
      <h1 className="text-[18px] font-medium">{title}</h1>
      <p className="text-gray-500">{description}</p>
    </div>
  );
}
